import React from "react";
import { connect } from "react-redux";

import SuppliersReportsDataTable from "./SuppliersReportsDataTable";

class SuppliersReportsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="sub-content">
        <SuppliersReportsDataTable />
      </div>
    );
  }
}

export default connect()(SuppliersReportsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/suppliersReports/SuppliersReportsPage.js